import Vue from 'vue'
import Buefy from 'buefy'
import CustomPageList from './App.vue'

Vue.use(Buefy,{
    defaultIconPack: 'fas',
})

Vue.use(CustomPageList)

if (document.getElementById("pagesListStaffApp")){
    new Vue({
        render:h=>h(
            CustomPageList,{
                props:{
                    listPagesUrl: document.getElementById("pagesListStaffApp")
                        .getAttribute("list-pages"),
                    formUrl: document.getElementById("pagesListStaffApp")
                        .getAttribute("create-form-url"),
                    deleteUrl: document.getElementById("pagesListStaffApp")
                        .getAttribute("delete-url")
                }
            }
        )
    }).$mount("#pagesListStaffApp")
}